export default __webpack_public_path__ + "static/media/wrapper-media2.a7d38cf4.jpg";